import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import Vue from "vue";
import Vuex from "vuex";
import buildConfig from "@/utils/config"; // import OSS from "ali-oss";

import plugins from "@/utils/plugins";
Vue.use(Vuex);
export default function (http, identity, _get_user_info) {
  var tokenKey = identity + "Token",
      schoolKey = identity + "School",
      breadKey = identity + "Breads";
  return new Vuex.Store({
    state: {
      webConfig: {},
      ossClient: null,
      token: localStorage[tokenKey] || "",
      user_info: {},
      school_info: {
        list: [],
        // 校区列表
        cur_school_id: 0,
        // 当前校区id
        cur_district_name: "",
        // 当前地区名称
        cur_school_name: "" // 当前校区名称

      },
      keywords: "",
      commonSetting: {
        point_info: {},
        course_name: {}
      },
      showLoginModal: false,
      liveSelect: {
        show: false,
        client_url: "",
        web_url: "",
        title: ""
      },
      breads: sessionStorage[breadKey] ? JSON.parse(sessionStorage[breadKey]) : [],
      search: "",
      svg: "",
      template: "rich",
      navigates: [],
      notReadNum: {
        all: 0,
        text: 0
      },
      message: {
        all: {},
        course: {},
        order: {},
        system: {},
        oto: {},
        exam: {}
      },
      homeworkTab: "",
      homeworkState: {},
      showLoading: false,
      formulaDlg: {
        show: false,
        uid: 0,
        selectionIndex: 0
      },
      couponDlg: {
        show: false,
        type: 1,
        // 1: 新人 2: 登录 3: 下单
        orderId: 0
      },
      keepAlivesFixed: [],
      // 固定 keepAlive
      keepAlivesDynamic: [],
      // 动态 keepAlive,
      memberLeftHeight: 0,
      indexData: {
        bannerList: [],
        recommendList: []
      },
      questionMode: "",
      questionModeSelect: "",
      showQuestionAnswer: {
        is_confirm: 0,
        get: false
      },
      testChecked: true //考试列表选中状态

    },
    getters: {
      // 校区数量
      schoolCount: function schoolCount(state) {
        var ret = 0;
        state.school_info.list.forEach(function (province) {
          province.city && province.city.forEach(function (city) {
            if (city.schools.length) {
              ret += city.schools.length;
            }
          });
        });
        return ret;
      },
      //vip是否展示
      showVip: function showVip(state) {
        if (state.commonSetting.switch_state == 2 || state.commonSetting.switch_vip_module == 0) {
          return false;
        }

        return true;
      },
      // 获取开关状态
      getSwitch: function getSwitch(state) {
        return function (key) {
          // 特殊开关处理
          switch (key) {
            //排课基础年级，课程分类
            case "grade":
            case "classify":
              return state.commonSetting["switch_sch_attr_".concat(key)] == 1;
            //合同排课

            case "contract":
              return state.commonSetting.switch_contract_schedule == 1;
            //线下考勤

            case "offline":
              return state.commonSetting.switch_offline_attend_mode == 1;
            //其他模块

            default:
              return state.commonSetting["switch_".concat(key, "_module")] == 1;
          }
        };
      }
    },
    mutations: {
      //设置考试列表选中状态
      setTestChecked: function setTestChecked(state, checked) {
        state.testChecked = checked;
      },
      setHomeworkTab: function setHomeworkTab(state, tab) {
        state.homeworkTab = tab;
      },
      setWebConfig: function setWebConfig(state, config) {
        console.log(4656, config);
        state.webConfig = config;
      },
      setCommonSetting: function setCommonSetting(state, setting) {
        state.commonSetting = setting;
      },
      login: function login(state, token) {
        state.token = token;
        localStorage[tokenKey] = token;
      },
      setUser: function setUser(state, info) {
        state.user_info = info;
      },
      logout: function logout(state) {
        state.token = "";
        state.user_info = {};
        localStorage.removeItem(tokenKey); // 这里不清空校区数据
      },
      setSchoolInfo: function setSchoolInfo(state, info) {
        state.school_info = info;
        this.commit("setSchoolID", info.cur_school_id);
      },
      clearSchoolInfo: function clearSchoolInfo(state) {
        state.school_info = {
          list: [],
          // 校区列表
          cur_school_id: 0,
          // 当前校区id
          cur_district_name: "",
          // 当前地区名称
          cur_school_name: "" // 当前校区名称

        };
        this.commit("clearShoolID");
      },
      setSchoolID: function setSchoolID(state, school_id) {
        localStorage[schoolKey] = school_id || "";
      },
      clearShoolID: function clearShoolID() {
        localStorage.removeItem(schoolKey);
      },
      search: function search(state, keywords) {
        state.keywords = keywords;
      },
      setMessage: function setMessage(state, message) {
        state.message = message;
      },
      showLogin: function showLogin(state, flag) {
        state.showLoginModal = flag;
      },
      showSelectLive: function showSelectLive(state, liveSelect) {
        state.liveSelect = liveSelect;
      },
      setBreads: function setBreads(state, route) {
        var bread = {
          title: typeof route.meta.title === "function" ? route.meta.title(route) : route.meta.title,
          name: route.name,
          routeName: route.name,
          query: route.query,
          params: route.params
        };
        var routeBread = typeof route.meta.root == "function" ? route.meta.root(route) : route.meta.root;

        if (routeBread) {
          state.breads = [bread];
        } else {
          // 如果在面包屑链中，直接跳至该面包屑
          var existBread = false;

          for (var i = 0; i < state.breads.length; ++i) {
            if (state.breads[i].name == bread.name) {
              existBread = true;
              state.breads.splice(i + 1);
              break;
            }
          }

          if (!existBread) {
            state.breads.push(bread);
          }
        }

        sessionStorage[breadKey] = JSON.stringify(state.breads);
      },
      setKeepAlive: function setKeepAlive(state, ary) {
        if (ary) {
          state.keepAlivesDynamic = ary;
        } else {
          var tmpAry = [];
          state.breads.forEach(function (i) {
            tmpAry.push(i.name);
          });
          state.keepAlivesDynamic = tmpAry;
        }
      },
      addKeepAlive: function addKeepAlive(state, name) {
        !state.keepAlivesDynamic.includes(name) && state.keepAlivesDynamic.push(name);
      },
      setSearch: function setSearch(state, search) {
        state.search = search;
      },
      setSvg: function setSvg(state, svg) {
        if (!svg) {
          return;
        }

        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = svg;
        var elements = tempDiv.querySelectorAll("path,g");
        elements.forEach(function (ele) {
          ele.removeAttribute("fill");
        });
        elements = tempDiv.querySelectorAll("svg");
        elements.forEach(function (ele) {
          ele.removeAttribute("width");
          ele.removeAttribute("height");
        });
        state.svg = tempDiv.innerHTML;
      },
      setNavigates: function setNavigates(state, navigates) {
        state.navigates = navigates;
      },
      setMessageRead: function setMessageRead(state, _ref) {
        var type = _ref.type;
        state.message[type].not_read--;
        state.message[type].not_read_show = state.message[type].not_read < 100 ? state.message[type].not_read : "99+";
        state.message.all.not_read--;
        state.message.all.not_read_show = state.message.all.not_read < 100 ? state.message.all.not_read : "99+";
      },
      setAllMessageRead: function setAllMessageRead(state) {
        for (var key in state.message) {
          state.message[key].not_read = 0;
          state.message[key].not_read_show = 0;
        }
      },
      setHomeworkState: function setHomeworkState(state, hw) {
        state.homeworkState = hw;
      },
      setLoading: function setLoading(state, show) {
        state.showLoading = show;
      },
      setMemberLeftHeight: function setMemberLeftHeight(state, height) {
        state.memberLeftHeight = height;
      },
      setOtherSetting: function setOtherSetting(state, setting) {
        state.otherSetting = setting; // const { oss_access_key_id, oss_access_key_secret } = setting;
        // init oss client
        // if (oss_access_key_id && oss_access_key_secret) {
        //   state.ossClient = new OSS({
        //     accessKeyId: setting.oss_access_key_id,
        //     accessKeySecret: setting.oss_access_key_secret,
        //     bucket: setting.oss_bucket,
        //     endpoint: setting.oss_endpoint,
        //     timeout: 180000,
        //   });
        // }
      },
      setIndexData: function setIndexData(state, _ref2) {
        var bannerList = _ref2.bannerList,
            recommendList = _ref2.recommendList;
        state.indexData.bannerList = bannerList;
        state.indexData.recommendList = recommendList;
      },
      setQuestionMode: function setQuestionMode(state, mode) {
        state.questionMode = mode;
      },
      setQuestionModeSelect: function setQuestionModeSelect(state, mode) {
        state.questionModeSelect = mode;
      },
      setShowQuestionAnswer: function setShowQuestionAnswer(state, obj) {
        state.showQuestionAnswer = obj;
      },
      setNotReadNum: function setNotReadNum(state, data) {
        state.notReadNum = data;
      },
      setCouponDlg: function setCouponDlg(state, data) {
        state.couponDlg = data;
      }
    },
    actions: {
      getIndexData: function () {
        var _getIndexData = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(_ref3) {
          var commit, _ref4, _ref5, bannerList, recommendList;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  commit = _ref3.commit;
                  commit("setLoading", true);
                  _context.next = 4;
                  return Promise.all([http.get("/api/app/banner", null, {
                    showLoading: false
                  }), http.get("/api/app/recommend/appIndex", null, {
                    showLoading: false
                  })]);

                case 4:
                  _ref4 = _context.sent;
                  _ref5 = _slicedToArray(_ref4, 2);
                  bannerList = _ref5[0];
                  recommendList = _ref5[1];
                  commit("setLoading", false);
                  recommendList.forEach(function (rec) {
                    var count = 0;

                    if (rec.channel_info.type == 4 || rec.channel_info.type == 6 || rec.channel_info.type == 5 || rec.channel_info.type == 9 || rec.channel_info.type == 8) {
                      count = 4;
                    } else if (rec.channel_info.type == 3) {// count = 5;
                    } else if (rec.channel_info.type == 1) {
                      count = 8;
                    } else if (rec.channel_info.type == 7 || rec.channel_info.type == 11 || rec.channel_info.type == 12) {
                      count = 6;
                    }

                    if (count > 0) {
                      rec.list = rec.list.splice(0, count);
                    }
                  });
                  commit("setIndexData", {
                    bannerList: bannerList,
                    recommendList: recommendList
                  });

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function getIndexData(_x) {
          return _getIndexData.apply(this, arguments);
        }

        return getIndexData;
      }(),
      getNavigator: function () {
        var _getNavigator = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2(_ref6) {
          var commit, _ref7, _ref8, navigates;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  commit = _ref6.commit;
                  commit("setLoading", true);
                  _context2.next = 4;
                  return Promise.all([http.get("/api/app/navigator", null, {
                    showLoading: false
                  })]);

                case 4:
                  _ref7 = _context2.sent;
                  _ref8 = _slicedToArray(_ref7, 1);
                  navigates = _ref8[0];
                  commit("setNavigates", navigates);

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function getNavigator(_x2) {
          return _getNavigator.apply(this, arguments);
        }

        return getNavigator;
      }(),
      getOtherSetting: function () {
        var _getOtherSetting = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3(_ref9) {
          var commit, setting;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  commit = _ref9.commit;
                  _context3.next = 3;
                  return http.get("/api/app/config/other_setting");

                case 3:
                  setting = _context3.sent;
                  commit("setOtherSetting", setting.other_setting);

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function getOtherSetting(_x3) {
          return _getOtherSetting.apply(this, arguments);
        }

        return getOtherSetting;
      }(),
      get_user_info: function () {
        var _get_user_info2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4(context) {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _get_user_info(context);

                case 2:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function get_user_info(_x4) {
          return _get_user_info2.apply(this, arguments);
        }

        return get_user_info;
      }(),
      get_user_info_friend: function () {
        var _get_user_info_friend = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5(context) {
          var data;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (context.state.token) {
                    _context5.next = 2;
                    break;
                  }

                  return _context5.abrupt("return");

                case 2:
                  _context5.next = 4;
                  return http.get("/api/app/userInfo", {}, {
                    onError: function onError(data) {
                      if (data.code == 202) {
                        context.commit("logout");
                      }
                    }
                  });

                case 4:
                  data = _context5.sent;
                  data.sex = data.sex.toString();
                  context.commit("setUser", data);

                case 7:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        function get_user_info_friend(_x5) {
          return _get_user_info_friend.apply(this, arguments);
        }

        return get_user_info_friend;
      }(),
      getSchoolInfo: function () {
        var _getSchoolInfo = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee6(_ref10) {
          var commit, datas, schoolID, curSchool;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  commit = _ref10.commit;
                  _context6.prev = 1;
                  _context6.next = 4;
                  return http.get("/api/app/getSchool", {}, {
                    allowReject: true
                  });

                case 4:
                  datas = _context6.sent;
                  schoolID = localStorage[schoolKey]; // console.log(datas, schoolID);

                  curSchool = _findSchool(datas, schoolID);

                  if (curSchool) {
                    _context6.next = 9;
                    break;
                  }

                  return _context6.abrupt("return");

                case 9:
                  // if (!curSchool) {
                  //   curSchool = _findSchool(datas);
                  // }
                  commit("setSchoolInfo", {
                    list: datas,
                    cur_school_id: curSchool.school_id,
                    cur_district_name: curSchool.district_name,
                    cur_school_name: curSchool.school_name
                  });
                  _context6.next = 14;
                  break;

                case 12:
                  _context6.prev = 12;
                  _context6.t0 = _context6["catch"](1);

                case 14:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, null, [[1, 12]]);
        }));

        function getSchoolInfo(_x6) {
          return _getSchoolInfo.apply(this, arguments);
        }

        return getSchoolInfo;
      }(),
      getWebConfig: function () {
        var _getWebConfig = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee7(_ref11, route) {
          var commit, config, setting, link;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  commit = _ref11.commit;
                  _context7.prev = 1;
                  _context7.next = 4;
                  return http.get("/api/app/config/system_webConfig", {}, {
                    allowReject: true
                  });

                case 4:
                  config = _context7.sent;
                  console.log(123, config);
                  commit("setWebConfig", config);
                  document.title = plugins.getTitle(config.web_title, route);
                  _context7.next = 10;
                  return buildConfig(http);

                case 10:
                  setting = _context7.sent;
                  commit("setCommonSetting", setting);
                  commit("setSvg", setting.ios_price_icon);
                  link = document.querySelector("link[rel*='icon']") || document.createElement("link");
                  link.type = "image/x-icon";
                  link.rel = "shortcut icon";
                  link.href = config.web_ico;
                  document.getElementsByTagName("head")[0].appendChild(link);
                  plugins.appendJs(setting.customer_service_code);
                  _context7.next = 24;
                  break;

                case 21:
                  _context7.prev = 21;
                  _context7.t0 = _context7["catch"](1);
                  console.log(_context7.t0);

                case 24:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, null, [[1, 21]]);
        }));

        function getWebConfig(_x7, _x8) {
          return _getWebConfig.apply(this, arguments);
        }

        return getWebConfig;
      }(),
      notReadMessage: function () {
        var _notReadMessage = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee8(_ref12) {
          var commit, res, num;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  commit = _ref12.commit;
                  _context8.next = 3;
                  return http.get("/api/lector/message/notReadNumber");

                case 3:
                  res = _context8.sent;
                  num = res.number < 100 ? res.number : "99+";
                  commit("setNotReadNum", {
                    all: res.number,
                    text: num
                  });

                case 6:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        function notReadMessage(_x9) {
          return _notReadMessage.apply(this, arguments);
        }

        return notReadMessage;
      }(),
      refreshMessageState: function () {
        var _refreshMessageState = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee9(context) {
          var message, not_read, list;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  message = {
                    all: {},
                    course: {},
                    order: {},
                    system: {},
                    oto: {},
                    exam: {}
                  };
                  not_read = 0;
                  _context9.next = 4;
                  return http.post("/api/app/message/classifyMessage", {}, {
                    onError: function onError(data) {
                      if (data.code == 202) {
                        context.commit("logout");
                      }
                    }
                  });

                case 4:
                  list = _context9.sent;
                  list.forEach(function (item) {
                    not_read += item.not_read;
                    message[item.message_classify] = {
                      not_read: item.not_read,
                      not_read_show: item.not_read < 100 ? item.not_read : "99+"
                    };
                  });
                  message["all"] = {
                    not_read: not_read,
                    not_read_show: not_read < 100 ? not_read : "99+"
                  };
                  context.commit("setMessage", message);

                case 8:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));

        function refreshMessageState(_x10) {
          return _refreshMessageState.apply(this, arguments);
        }

        return refreshMessageState;
      }(),
      refreshHomeworkState: function () {
        var _refreshHomeworkState = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee10(context) {
          var data, state;
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return http.get("/api/app/user/homework/listNum", {}, {
                    onError: function onError() {}
                  });

                case 2:
                  data = _context10.sent;
                  state = {
                    count: data.no_submit_num,
                    count_show: data.no_submit_num < 100 ? data.no_submit_num : "99+"
                  };
                  context.commit("setHomeworkState", state);

                case 5:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }));

        function refreshHomeworkState(_x11) {
          return _refreshHomeworkState.apply(this, arguments);
        }

        return refreshHomeworkState;
      }()
    }
  });
}

function _findSchool(provinces, schoolID) {
  if (provinces && provinces.length) {
    // 有 schoolID 则寻找，没有则拿第一个校区
    if (schoolID) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = provinces[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var province = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = province.city[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var city = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = city.schools[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var school = _step3.value;

                  if (school.school_id == schoolID) {
                    return {
                      school_id: school.school_id,
                      district_name: school.district_name,
                      school_name: school.school_name
                    };
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    if (provinces[0].city.length && provinces[0].city[0].schools.length) {
      var _school = provinces[0].city[0].schools[0];
      return {
        school_id: _school.school_id,
        district_name: _school.district_name,
        school_name: _school.school_name
      };
    }
  }

  return null;
}